/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import "./HousekeepingHero.css";
import Navbar from "../../Header/Navbar";

const CorporatePestControlHero = () => {
  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
      <section className="hk-hero">
        <div className="hk-container">
          
          {/* Main Title */}
          <h1 className="hk-title">Corporate Pest Control Services</h1>

          {/* Subtitle with Links */}
          <p className="hk-subtitle">
            <Link to="/" className="hk-breadcrumb-link">Home</Link>
            <span className="hk-breadcrumb-separator"> - </span>

            <Link to="/services" className="hk-breadcrumb-link">Our Services</Link>
            <span className="hk-breadcrumb-separator"> - </span>

            <Link 
              to="" 
              className="hk-breadcrumb-link"
            >
              Corporate Pest Control Services
            </Link>
          </p>

        </div>
      </section>

      {/* About Tag BELOW HERO */}
      <div className="hk-tag-wrapper">
        <div className="hk-tag">About This Service</div>
      </div>
    </>
  );
};

export default CorporatePestControlHero;
